import './styles/tailwind.css'
import './styles/app.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-phone-number-input/style.css'

import { createRoot } from 'react-dom/client'

import App from './App'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
